import styles from "./../buttons.module.scss"
import React, { useLayoutEffect, useRef, useState } from "react";
import classNames from "classnames";
import { InlineLoader } from "../Loaders";
import Tooltip from "./Tooltip";

export const getBaseClassName = ({ type, color, variant }) => {
    let baseClassName;

    if ((!type && !variant) || variant === "square") {
        if (color === "secondary") {
            baseClassName = styles.secondary
        } else if (color === "destructive" || color === "error") {
            baseClassName = styles.destructive
        } else {
            baseClassName = styles.primary;
        }
    } else if (type === "text" || variant === "text") {
        if (color === "secondary") {
            baseClassName = styles['text-secondary'];
        } else {
            baseClassName = styles['text'];
        }
    } else if (type === "icon" || variant === "icon") {
        if(color === "secondary") {
            baseClassName = styles['icon-secondary'];
        } else {
            baseClassName = styles['icon']
        }
    } else if (type === "none" || variant === "none") {
        baseClassName = styles["none"];
    }

    return baseClassName;
}

const TextLoader = ({ originalText }) => {
    const ref = useRef(null);
    const [width, setWidth] = useState(null);

    useLayoutEffect(() => {
        setWidth(ref.current.getBoundingClientRect().width);
    }, [setWidth]);

    if (width === null) {
        return <span ref={ref}>
            {originalText}
        </span>
    } else {
        return <span style={{ minWidth: width || 0 }} className={styles['text-loader']}>
                <InlineLoader className={styles.loader}/>
        </span>
    }
}

/**
 * @param variant: square (default), text, icon, none
 round, dropdown, ovalaction, roundaction  (pending implementation)
 * @param color:    square - primary, secondary, error
 text - primary, secondary
 */
const Button = ({ children, className, style, color, type, variant, large, disabled, isSubmitting, tooltip, submit, ariaLabel, ...rest }) => {
    const baseClassName = getBaseClassName({ type, color, variant });

    const _className = classNames(baseClassName, className, { [styles.large]: large });
    return <button type={submit ? "submit" : "button"} disabled={isSubmitting || disabled} className={_className} {...rest} style={style} aria-label={ariaLabel}>
        {isSubmitting ? ((variant === "text" || type === "text") ? <TextLoader originalText={children}/> : <InlineLoader className={styles.loader} color="inherit"/>) : children}
        {tooltip && <Tooltip>{tooltip}</Tooltip>}
    </button>
}

export default Button;
